/**
 * ChunkCitations — the cited chunk *titres* the answer was grounded on (the RBAC-scoped retrieval
 * result, `answer.chunks_utilises`). Rendered under an `ok` assistant turn as discreet source chips so
 * the user can trace the answer to the lab SOP / product-help titles. Capability-scoping happens
 * server-side (a chunk the user can't see is never retrieved); we only display what came back.
 */
import { useT } from "@/app";
import { Badge } from "@/ui";

export interface ChunkCitationsProps {
  titres: ReadonlyArray<string>;
}

export function ChunkCitations({ titres }: ChunkCitationsProps) {
  const { t } = useT();
  if (!titres || titres.length === 0) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--nv-s-1)" }}>
      <span style={{ fontSize: "var(--nv-fs-caption)", color: "var(--nv-steel)" }}>
        {t("ai.assistant.citations.title")} · {t("ai.assistant.citations.count", { n: titres.length })}
      </span>
      <ul
        style={{
          listStyle: "none",
          margin: 0,
          padding: 0,
          display: "flex",
          flexWrap: "wrap",
          gap: "var(--nv-s-2)",
        }}
      >
        {titres.map((titre, i) => (
          <li key={`${titre}-${i}`}>
            <Badge tone="info" glyph="❝">
              {titre}
            </Badge>
          </li>
        ))}
      </ul>
    </div>
  );
}
